import { Slider } from '@ubnt/ui-components/Slider';
import { styled, css } from 'styled-components';
import { BREAKPOINTS } from '../../constants/layout.mjs';
import { theme } from '../../constants/theme.mjs';
import '../StyleableSvgImage/index.mjs';
import { StyleableSvgImage } from '../StyleableSvgImage/StyleableSvgImage.mjs';
"use strict";
const ControlWrap = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;

  margin: auto 20px 20px;

  opacity: 0;

  transition: opacity 0.2s ease-in-out 1.5s;
`;
const Wrap = styled.div`
  display: none;
  position: relative;
  z-index: 100;
  height: 100%;

  background-color: ${theme.colors.white};

  &:hover {
    ${ControlWrap} {
      opacity: 1;
      transition: opacity 0.2s ease-in-out 0.1s;
    }
  }

  ${({
  isOpen
}) => isOpen && css`
      display: block;
    `}
`;
const Video = styled.video`
  width: 100%;
  height: 100%;
  display: block;

  border-radius: inherit;
`;
const Controls = styled.div`
  display: flex;
  align-items: center;

  > * {
    display: flex;
    align-items: center;
    gap: 10px;

    flex: 1;
  }
`;
const LeftSide = styled.div`
  justify-content: flex-start;
`;
const RightSide = styled.div`
  justify-content: flex-end;
`;
const Center = styled.div`
  justify-content: center;
  line-height: ${19.33 / 16};
  letter-spacing: -2%;
  text-align: center;

  ${({
  $motif
}) => $motif === "dark" ? css`
          color: ${theme.colors.vulcan};
        ` : css`
          color: ${theme.colors.white};
        `}

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    display: none;
  }
`;
const IconButton = styled.button`
  background-color: transparent;
  border: none;
  padding: 0;
  margin: 0;

  cursor: pointer;
`;
const Icon = styled(StyleableSvgImage)`
  ${({
  $motif
}) => $motif === "dark" ? css`
          color: ${theme.colors.vulcan};
        ` : css`
          color: ${theme.colors.white};
        `}
`;
const IconWrap = styled.div`
  position: absolute;

  top: 30px;

  ${({
  $alignRight
}) => $alignRight ? css`
          right: 30px;
        ` : css`
          left: 30px;
        `}

  cursor: pointer;
  z-index: 100;
`;
const Time = styled.div`
  line-height: ${19.33 / 16};
  letter-spacing: -2%;

  ${({
  $motif
}) => $motif === "dark" ? css`
          color: ${theme.colors.vulcan};
        ` : css`
          color: ${theme.colors.white};
        `}

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    display: none;
  }
`;
const TimelineInput = styled.input`
  width: 100%;
`;
const thumbClassName = "custom-thumb";
const trackClassName = "custom-track";
const Timeline = styled(Slider).attrs({
  thumbClassName,
  trackClassName
})`
  margin: 0 -6px 10px;

  width: calc(100% + 12px);

  .${thumbClassName} {
    background-color: ${theme.colors.primaryBlue};
    width: 10px;
    height: 10px;
    border: none;
  }
`;
const TimelineWrap = styled.div`
  ${Timeline} {
    > div div[class*="track"] {
      background-color: ${theme.colors.black10};

      ${({
  $motif
}) => $motif === "dark" ? css`
              background-color: ${theme.colors.black10};
            ` : css`
              background-color: ${theme.colors.athensGreyLight};
            `}
    }
  }
`;
const VolumeSliderWrap = styled.div`
  position: absolute;
  bottom: calc(100%);

  opacity: 0;
  visibility: hidden;

  transition:
    visibility 0.3s linear 1s,
    0.2s opacity ease-out 1s;

  height: 80px;
  width: 18px;
  border-radius: 4px;
  margin-bottom: 9px;

  background-color: ${theme.colors.black45};
`;
const volumeThumbClassName = "volume-thumb";
const VolumeSlider = styled(Slider).attrs({
  thumbClassName: volumeThumbClassName
})`
  margin: 0 -20px;

  top: 50%;
  left: 100%;

  .${volumeThumbClassName} {
    background-color: ${theme.colors.white};
    border: none;

    width: 10px;
    height: 10px;

    filter: none;
  }

  > div > div:last-child {
    background-color: ${theme.colors.black20};
    border-radius: 12px;
    height: 4px;
  }
`;
const VolumeWrap = styled.div`
  position: relative;
  height: 22px;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    ${VolumeSliderWrap} {
      opacity: 1;
      visibility: visible;

      transition:
        visibility 0.3s ease-out 0.1s,
        0.2s opacity ease-out 0.1s;
    }
  }
`;
export { Center, ControlWrap, Controls, Icon, IconButton, IconWrap, LeftSide, RightSide, Time, Timeline, TimelineInput, TimelineWrap, Video, VolumeSlider, VolumeSliderWrap, VolumeWrap, Wrap };
//# sourceMappingURL=VideoPlayer.styles.mjs.map
